<form [formGroup]="form" class="shifts-number">
	<label class="label">{{ 'company-general-info.shifts-number.label' | translate }}</label>
	<div class="shifts-number-input">
		<div class="shifts-radio-buttons">
			<nb-radio-group class="radio-group" name="shifts" id="shifts_{{standard.toLowerCase()}}" [formControlName]="fullControlName('shiftsNumber')"
							[attr.formcontrolname]="fullControlName('shiftsNumber')" [status]="isInvalid('shiftsNumber') ? 'danger' : 'primary'"
							[disabled]="shouldDisableRadio(fullControlName('shiftsNumber'))">
				<nb-radio [value]="1">{{ 'common.one' | translate }}</nb-radio>
				<nb-radio [value]="2">{{ 'common.two' | translate }}</nb-radio>
				<nb-radio [value]="3">{{ 'common.three' | translate }}</nb-radio>
				<nb-radio [value]="0">{{ 'common.more' | translate }}</nb-radio>
			</nb-radio-group>
			@if (isInvalid('shiftsNumber')) {
				<div class="validation-message margin-left-15">{{ getValidationErrors('shiftsNumber') | async }}</div>
			}
		</div>
		@if (isFormControlIncludedInForm('shiftsNumberMore')) {
			<div class="col-md-3 more-shifts">
				<ng-select id="shifts-number-more_{{standard.toLowerCase()}}" [items]="selectableShiftsMore" [placeholder]="'common.select' | translate" [multiple]="false" [searchable]="false"
						   [clearable]="false"
						   [hideSelected]="true" [closeOnSelect]="true" [dropdownPosition]="'top'" [formControlName]="fullControlName('shiftsNumberMore')"
						   [attr.formcontrolname]="fullControlName('shiftsNumberMore')">
				</ng-select>
				@if (isInvalid('shiftsNumberMore')) {
					<div class="validation-message">{{ getValidationErrors('shiftsNumberMore') | async }}</div>
				}
			</div>
		}
	</div>
</form>
